// extracted by mini-css-extract-plugin
export var linkText = "_ot-0";